// Initialisation
$('[data-toggle="popover"]').popover();

$('[data-toggle="popover"]').on('click', function (){
  return false;
});
